import React from 'react';

import Icon from 'components/mweb/Icon/Icon';

import './membership-plan.scss';

const MembershipPlan = ({
  data = [],
  selectedPlan = {},
  updateSelectedPlan = () => {},
}) => {
  return (
    <>
      {data?.map((item, index) => {
        const {
          title = '',
          description = '',
          retailPrice = 0,
          salePrice,
          saleOn,
        } = item;
        const onSale = saleOn && salePrice < retailPrice;
        return (
          <div
            className="membership-plan-card"
            key={index}
            onClick={() => updateSelectedPlan(item)}
          >
            <div className="membership-plan--info-container">
              <span className="membership-plan-title">{title}</span>
              <span className="membership-plan-description">{description}</span>
            </div>
            <div className="membership-plan-price-wrapper">
              <span
                className={`${
                  onSale
                    ? 'membership-plan-price'
                    : 'membership-plan--sale-price'
                }`}
              >
                {' '}
                &#8377;{retailPrice}
              </span>
              {onSale && (
                <span className="membership-plan--sale-price">
                  {' '}
                  &#8377;{salePrice}
                </span>
              )}
              {selectedPlan?.hbMembershipId === item?.hbMembershipId ? (
                <Icon
                  class="icon-hb-prime-checkbox-check membership-plan-icon"
                  size={16}
                />
              ) : (
                <Icon
                  class="icon-hb-prime-checkbox-uncheck membership-plan-icon"
                  size={16}
                />
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default MembershipPlan;
